import { Link } from 'react-router-dom';

import { getRecordName } from '@/app/projectRecord/_helpers';
import { formatRelativeShort } from '@/helpers/date';
import { cn } from '@/helpers/shadcn';
import { useRecentEstimateObject } from '@/data/recentEstimate';

// A single recent estimate row inside the navigation rail's Estimate flyout.
const ViewRecentEstimateForNavigation = ({ uid }) => {
  const recentEstimate = useRecentEstimateObject(uid);

  // The estimate may have been deleted while still cached in the recent list — the
  // backend can no longer join the project record, so there is nothing to show.
  if (!recentEstimate?.project_record?.project) {
    return null;
  }

  const projectRecord = recentEstimate.project_record;
  const isConsolidated = projectRecord.estimate.is_consolidated;

  return (
    <Link to={`/estimate/${uid}`} data-testid={`nav-recent-estimate-${uid}`} className="flex items-center gap-3 rounded-xl p-2 hover:bg-accent transition-colors">
      <div
        className={cn(
          'flex size-8 shrink-0 items-center justify-center rounded-lg text-xs font-bold',
          isConsolidated ? 'bg-record-consolidated text-record-consolidated-foreground' : 'bg-record-estimate text-record-estimate-foreground'
        )}
      >
        {isConsolidated ? 'C' : 'E'}
      </div>
      <div className="min-w-0 flex-auto">
        <div className="truncate text-sm font-medium" data-testid={`nav-recent-estimate-${uid}-name`}>
          {getRecordName(projectRecord)}
        </div>
        <div className="truncate text-xs text-muted-foreground">
          {formatRelativeShort(recentEstimate.accessed_ts)} &bull; {projectRecord.project.project_name}
        </div>
      </div>
    </Link>
  );
};

export default ViewRecentEstimateForNavigation;
